<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>자격증 발급(재발급)</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>자격증 발급(재발급)</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="inform_box">
            <ol class="dot">
              <li class="color">
                <span class="ol_li_txt">
                  2020년 이전 자격증은 여기로 접수 바랍니다.
                  <button class="btn" @click="fnModal('', '', 1, -1)">발급 신청</button>
                </span>
              </li>
            </ol>
          </div>
          <div class="table mt30">
            <div class="row head">
              <div class="cell fix150"><p>번호</p></div>
              <div class="cell"><p>제목</p></div>
              <div class="cell fix150"><p>접수일</p></div>
              <div class="cell fix180"><p>자격증 발급</p></div>
            </div>
            <div class="page_con" v-if="$Util.isEmpty(list)">
              <div class="empty_wrap">
                <div class="empty">
                  <span>내역이 존재하지 않습니다.</span>
                </div>
              </div>
            </div>
            <div class="row" v-for="(item, index) in list" :key="index">
              <div class="cell fix150">
                <p>{{ pageInfo.virtualNum - index }}</p>
              </div>
              <div class="cell">
                <p class="left">
                  {{ item.exam.examinationName }}
                </p>
              </div>
              <div class="cell fix150"><p>{{ $moment(item.userExam.examRegDate).format('YYYY.MM.DD') }}</p></div>
              <div class="cell fix180">
                <button
                  class="btn bo"
                  @click="fnModal(item.exam.examinationName, item.userExam.userExaminationNo, '', item.cert.certificateNo)"
                  :class="{ 'grey' : item.cert.count > 0 }"
                >
                  {{ $Util.isEmpty(item.cert.count) || item.cert.count === 0  ? '발급하기' : '재발급' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-exam-certificate-index',
  description: '자격증 발급',
  data() {
    return {
      list: [],
      pageInfo: {},
      params: {
        page: 1,
        limit: 10,
        passStatus: 1,
        passDate: '1',
        isPass: '1'
      }
    }
  },
  async created() {
    const res = await this.$ManagerSvc.fetchUserCertList(this.params)
    console.log('res:::', res)
    this.list = res.entity.list
    this.pageInfo = res.entity.pageInfo
  },
  methods: {
    fetchData: async function() {
      const res = await this.$ManagerSvc.fetchUserCertList(this.params)
      this.list = res.entity.list
      this.pageInfo = res.entity.pageInfo
    },
    fnModal: function(name, userExaminationNo, isBefore, certificateNo) {
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames
          .MODAL_EXAM_CERTIFICATION_REAPPLY_POPUP,
        data: { name, userExaminationNo, isBefore, certificateNo },
        callBack: () => {},
      })
    }
  }
}
</script>

<style scoped></style>
